export class YoutubeBg {
  constructor () {
    this.nodes = [...document.querySelectorAll('[data-yt-bg]')]

    if (!this.nodes.length) {
      return
    }

    if (window.YT?.Player) {
      this.mountAll()
      return
    }

    const previous = window.onYouTubeIframeAPIReady
    window.onYouTubeIframeAPIReady = () => {
      previous?.()
      this.mountAll()
    }

    if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
      const script = document.createElement('script')
      script.src = 'https://www.youtube.com/iframe_api'
      document.head.appendChild(script)
    }
  }

  mountAll () {
    this.nodes.forEach((el) => this.mount(el))
  }

  mount (el) {
    const id = el.dataset.ytId

    if (!id || !window.YT?.Player) {
      return
    }

    new window.YT.Player(el, {
      videoId: id,
      width: '100%',
      height: '100%',
      playerVars: {
        autoplay: 1,
        mute: 1,
        controls: 0,
        disablekb: 1,
        fs: 0,
        iv_load_policy: 3,
        playsinline: 1,
        rel: 0,
        origin: window.location.origin,
      },
      events: {
        onReady (event) {
          event.target.mute()
          event.target.playVideo()
        },
        onStateChange (event) {
          if (event.data === window.YT.PlayerState.PLAYING) {
            event.target.getIframe()?.classList.add('video-started')
          }

          if (event.data === window.YT.PlayerState.ENDED) {
            event.target.seekTo(0)
            event.target.playVideo()
          }
        },
      },
    })
  }
}
